import { GlobalState } from '../../reducers';

export const getUser = (state: GlobalState) => state.user.user;
